import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  mostEngaged: {
    key: `ContextList-mostEngaged`,
    defaultValue: `Mais engajados`,
  },
  happeningNow: {
    key: `ContextList-happeningNow`,
    defaultValue: `Acontecendo agora`,
  },
  launches: {
    key: `ContextList-launches`,
    defaultValue: `Lançamentos`,
  },
  trendingProducts: {
    key: `ContextList-trendingProducts`,
    defaultValue: `Produtos em alta`,
  },
  painPoints: {
    key: `ContextList-painPoints`,
    defaultValue: `Pain points`,
  },
  paidPartnerships: {
    key: `ContextList-paidPartnerships`,
    defaultValue: `Parcerias pagas`,
  },
  promotionsDiscounts: {
    key: `ContextList-promotionsDiscounts`,
    defaultValue: `Promoções e descontos`,
  },
  sponsoredEvents: {
    key: `ContextList-sponsoredEvents`,
    defaultValue: `Eventos patrocinados`,
  },
})
